import styled from 'styled-components';
import IconArrowDownOutline from './IconArrowDownOutline';
var IconArrowRightOutline = /*#__PURE__*/styled(IconArrowDownOutline).withConfig({
  displayName: "IconArrowRightOutline",
  componentId: "c11n-8-107-0__sc-a71fta-0"
})(["transform:rotate(270deg);"]);
export default IconArrowRightOutline;